import styles from './HeadingWithId.css'
import Tip from '../Tip'
import PropTypes from 'prop-types'

/** 編號與標題 */
const HeadingWithId = props => {
  const {
    children,
    subtitle,
    title
  } = props

  return (
    <div
      className={styles.HeadingWithId}
      data-role='heading-with-id'
    >
      <h2
        key='heading'
        className={styles.heading}
      >
        {title}
      </h2>
      <Tip
        type='info'
        className={styles.subtitleWithId}
      >
        {subtitle}
      </Tip>
      {children}
    </div>
  )
}

HeadingWithId.propTypes = {
  title: PropTypes.string.isRequired
}

export default HeadingWithId
